import { convertNumberToWords, currency } from "../../utils/number.utils";
import { textToNumber } from "../../utils/string.utils";
export default function CustomerBankTotalField({ watch, control, errors, setValue }) {
  // total calculation
  const price = textToNumber(watch("customer.bank_will_pay"));
  const registrationCost = textToNumber(watch("customer.customer_will_pay"));

  const singleTotal = price + registrationCost;

  const total = currency(singleTotal);
  const inwords = convertNumberToWords(singleTotal);
  return (
    <div className="card mb-3">
      <div className="card-body">
        <p className="mb-0">
          <span style={{ fontWeight: 600 }}>Total:</span> {total}
        </p>
        <p className="mb-0">
          <span style={{ fontWeight: 600 }}>Inwords:</span> {inwords}
        </p>
      </div>
    </div>
  );
}
